import { useSelector } from 'react-redux'
import { hasActiveProject } from 'src/redux/slices/project/selectors'

import Dashboard from '../components/Dashboard'
import NoProjectWidget from '../components/NoProjectWidget'

///// Component
const ProjectPage: React.FC = () => {
  const active = useSelector(hasActiveProject)
  return active ? <Dashboard /> : <NoProjectWidget />
}

export default ProjectPage
